import script from "./procureWarehouse.vue?vue&type=script&setup=true&lang=js"
export * from "./procureWarehouse.vue?vue&type=script&setup=true&lang=js"

import "./procureWarehouse.vue?vue&type=style&index=0&id=29a56921&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29a56921"]])

export default __exports__